import { memo, useCallback } from 'react';
import { Screen, useNavigation } from '@bonanza-social/navigation';
import StatusOnboarding from '../components/StatusOnboarding/StatusOnboarding';

function StatusOnboardingScreen() {
  const navigation = useNavigation();

  const onInitialAnimationFinished = useCallback(() => {
    navigation.setOptions({
      headerShown: true,
    });
  }, [navigation]);

  return (
    <Screen paddingHorizontal="space-0" backgroundColor="transparent">
      <StatusOnboarding
        flex={1}
        paddingTop="space-600"
        backgroundColor="backdropSecondary"
        paddingBottom="safe-area-inset-bottom"
        onInitialAnimationFinished={onInitialAnimationFinished}
      />
    </Screen>
  );
}

export default memo(StatusOnboardingScreen);
